import { LoyaltyPointsUser, StoreCoupons } from "../components";
import { useAuth, useStore } from "../hooks";
import { Layout } from "../layouts";
import { Col, Row } from "react-bootstrap";

const OffersPage = () => {
  const { isLoggedIn, isGuest } = useAuth();
  const { isLoyaltyActive, isGiftcardActive } = useStore();

  return (
    <Layout>
      <div className="choose_payment_method_main offer-and-reward">
        {(isGiftcardActive || isLoyaltyActive) && isLoggedIn && !isGuest && (
          <>
            <h2 className="page-heading">Offer & Rewards</h2>
            <Row className="offer_reward_banner">
              {isLoyaltyActive && (
                <Col md={6}>
                  <LoyaltyPointsUser />
                </Col>
              )}

              {/* {isGiftcardActive && (
                <Col md={6}>
                  <GiftCardBox />
                </Col>
              )} */}
            </Row>
          </>
        )}

        <StoreCoupons />
      </div>
    </Layout>
  );
};

export default OffersPage;
